import { render, staticRenderFns } from "./Product_Setting.vue?vue&type=template&id=2ec2e373&scoped=true&"
import script from "./Product_Setting.vue?vue&type=script&lang=js&"
export * from "./Product_Setting.vue?vue&type=script&lang=js&"
import style0 from "./Product_Setting.vue?vue&type=style&index=0&id=2ec2e373&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec2e373",
  null
  
)

export default component.exports